'use client';

import { FC } from 'react';

import { DynamicIcon } from '@purpur/library/dynamic-icon';
import { Icon, IconBaseProps } from '@purpur/library/icon';

import { getLocalSvgIcon, isPurpurIconName } from './utils';

export type NamedIconProps = IconBaseProps & { name: string };

export const NamedIcon: FC<NamedIconProps> = ({ name, ...props }) => {
    if (isPurpurIconName(name)) {
        return <DynamicIcon name={name} {...props} />;
    }

    return <Icon svg={getLocalSvgIcon(name)} {...props} />;
};
